import {
  DISPLAY_DEFAULT_REPORTS,
  DISPLAY_DEFAULT_REPORTS_FAILED,
  DISPLAY_DEFAULT_REPORTS_SUCCESS,
  GET_ACTIVE_SITE_USERS,
  GET_ACTIVE_SITE_USERS_FAILED,
  GET_ACTIVE_SITE_USERS_SUCCESS,
  GET_ACTIVE_USERS_REPORTS,
  GET_ACTIVE_USERS_REPORTS_FAILED,
  GET_ACTIVE_USERS_REPORTS_SUCCESS,
  GET_AD_REPORTS,
  GET_AD_REPORTS_FAILED,
  GET_AD_REPORTS_SUCCESS,
  GET_ALL_FEATURE_REPORTS,
  GET_ALL_FEATURE_REPORTS_FAILED,
  GET_ALL_FEATURE_REPORTS_SUCCESS,
  GET_ALL_USER_RESPONSES,
  GET_ALL_USER_RESPONSES_FAILED,
  GET_ALL_USER_RESPONSES_SUCCESS,
  GET_APP_OPENS_MONTH_REPORT,
  GET_APP_OPENS_MONTH_REPORT_FAILED,
  GET_APP_OPENS_MONTH_REPORT_SUCCESS,
  GET_APP_OPENS_REPORTS,
  GET_APP_OPENS_REPORTS_FAILED,
  GET_APP_OPENS_REPORTS_SUCCESS,
  GET_BOOKING_PAYMENT_REPORTS,
  GET_BOOKING_PAYMENT_REPORTS_FAILED,
  GET_BOOKING_PAYMENT_REPORTS_SUCCESS,
  GET_DASHBOARD_SECTIONS,
  GET_DASHBOARD_SECTIONS_FAILED,
  GET_DASHBOARD_SECTIONS_SUCCESS,
  GET_FEATURE_CLICKS,
  GET_FEATURE_CLICKS_FAILED,
  GET_FEATURE_CLICKS_SUCCESS,
  GET_FEATURE_RESPONSES_BY_USER,
  GET_FEATURE_RESPONSES_BY_USER_FAILED,
  GET_FEATURE_RESPONSES_BY_USER_SUCCESS,
  GET_FEATURE_USAGE_REPORT,
  GET_FEATURE_USAGE_REPORT_FAILED,
  GET_FEATURE_USAGE_REPORT_SUCCESS,
  GET_FEATURE_VIEWS_BY_USER,
  GET_FEATURE_VIEWS_BY_USER_FAILED,
  GET_FEATURE_VIEWS_BY_USER_SUCCESS,
  GET_FORM_BUILDER_PAYMENT_REPORTS,
  GET_FORM_BUILDER_PAYMENT_REPORTS_FAILED,
  GET_FORM_BUILDER_PAYMENT_REPORTS_SUCCESS,
  GET_FORM_LIST_FAILED,
  GET_FORM_LIST_SUCCESS,
  GET_NEW_USERS_REPORTS,
  GET_NEW_USERS_REPORTS_FAILED,
  GET_NEW_USERS_REPORTS_SUCCESS,
  GET_RECENT_EXPERIENCES,
  GET_RECENT_EXPERIENCES_FAILED,
  GET_RECENT_EXPERIENCES_SUCCESS,
  GET_USER_REPORTS,
  GET_USER_REPORTS_FAILED,
  GET_USER_REPORTS_SUCCESS,
  RESET_ALL_USER_RESPONSES,
  RESET_APP_OPENS_REPORTS,
  RESET_FEATURE_CLICKS,
  RESET_FEATURE_RESPONSES_BY_USER,
  RESET_FEATURE_USAGE_REPORT,
  RESET_FEATURE_VIEWS_BY_USER,
  UPDATE_DASHBOARD_SECTIONS,
  UPDATE_DASHBOARD_SECTIONS_FAILED,
  UPDATE_DASHBOARD_SECTIONS_SUCCESS,
} from "./actionTypes"

const INIT_STATE = {
  loading: false,
  error: "",
  dashboardSections: null,
  userReports: null,
  activeUsersReports: null,
  newUsersReports: null,
  recentExperiences: null,
  adReports: null,
  bookingPaymentReports: null,
  featureResponsesByUser: null,
  allUserResponses: null,
  featureUsageReport: null,
  appOpensReports: [],
  appOpensMonthReport: [],
  activeSiteUsers: [],
  formBuilderPaymentReports: null,
  formList: [],
  featureClicks: null,
  featureViewsByUser: null,
  dashboardReportsAreLoading: false,
  featureReportsLoading: false
}

const Analytics = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_USER_REPORTS:
    case GET_ACTIVE_USERS_REPORTS:
    case GET_NEW_USERS_REPORTS:
    case GET_RECENT_EXPERIENCES:
    case GET_AD_REPORTS:
    case GET_BOOKING_PAYMENT_REPORTS:
    case GET_DASHBOARD_SECTIONS:
    case UPDATE_DASHBOARD_SECTIONS:
    case GET_FEATURE_RESPONSES_BY_USER:
    case GET_FEATURE_USAGE_REPORT:
    case GET_APP_OPENS_REPORTS:
    case GET_ACTIVE_SITE_USERS:
    case GET_APP_OPENS_MONTH_REPORT:
    case GET_ALL_USER_RESPONSES:
    case GET_FORM_BUILDER_PAYMENT_REPORTS:
    case GET_FEATURE_CLICKS:
    case GET_FEATURE_VIEWS_BY_USER:
      return {
        ...state,
        loading: true,
      }
    case GET_USER_REPORTS_FAILED:
    case GET_ACTIVE_USERS_REPORTS_FAILED:
    case GET_NEW_USERS_REPORTS_FAILED:
    case GET_RECENT_EXPERIENCES_FAILED:
    case GET_AD_REPORTS_FAILED:
    case GET_BOOKING_PAYMENT_REPORTS_FAILED:
    case GET_DASHBOARD_SECTIONS_FAILED:
    case UPDATE_DASHBOARD_SECTIONS_FAILED:
    case GET_FEATURE_RESPONSES_BY_USER_FAILED:
    case GET_FEATURE_USAGE_REPORT_FAILED:
    case GET_APP_OPENS_REPORTS_FAILED:
    case GET_ACTIVE_SITE_USERS_FAILED:
    case GET_APP_OPENS_MONTH_REPORT_FAILED:
    case GET_ALL_USER_RESPONSES_FAILED:
    case GET_FORM_BUILDER_PAYMENT_REPORTS_FAILED:
    case GET_FORM_LIST_FAILED:
    case GET_FEATURE_CLICKS_FAILED:
    case GET_FEATURE_VIEWS_BY_USER_FAILED:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }
    case GET_USER_REPORTS_SUCCESS:
      return {
        ...state,
        userReports: action.payload,
        loading: false,
      }
    case GET_ACTIVE_USERS_REPORTS_SUCCESS:
      return {
        ...state,
        activeUsersReports: action.payload,
        loading: false,
      }
    case GET_NEW_USERS_REPORTS_SUCCESS:
      return {
        ...state,
        newUsersReports: action.payload,
        loading: false,
      }
    case GET_RECENT_EXPERIENCES_SUCCESS:
      return {
        ...state,
        recentExperiences: action.payload,
        loading: false,
      }
    case GET_AD_REPORTS_SUCCESS:
      return {
        ...state,
        adReports: action.payload,
        loading: false,
      }
    case GET_BOOKING_PAYMENT_REPORTS_SUCCESS:
      return {
        ...state,
        bookingPaymentReports: action.payload,
        loading: false,
      }
    case GET_DASHBOARD_SECTIONS_SUCCESS:
    case UPDATE_DASHBOARD_SECTIONS_SUCCESS:
      return {
        ...state,
        dashboardSections: action.payload,
        loading: false,
      }
    case GET_FEATURE_RESPONSES_BY_USER_SUCCESS:
      return {
        ...state,
        featureResponsesByUser: action.payload,
        loading: false,
      }
    case RESET_FEATURE_RESPONSES_BY_USER:
      return {
        ...state,
        featureResponsesByUser: null,
      }
    case GET_FEATURE_USAGE_REPORT_SUCCESS:
      return {
        ...state,
        featureUsageReport: action.payload,
        loading: false,
      }
    case GET_APP_OPENS_REPORTS_SUCCESS:
      return {
        ...state,
        appOpensReports: action.payload,
        loading: false,
      }
    case GET_ACTIVE_SITE_USERS_SUCCESS:
      return {
        ...state,
        activeSiteUsers: action.payload,
        loading: false,
      }
    case RESET_FEATURE_USAGE_REPORT:
      return {
        ...state,
        featureUsageReport: null,
      }
    case RESET_APP_OPENS_REPORTS:
      return {
        ...state,
        appOpensReports: [],
        appOpensMonthReport: [],
      }
    case GET_APP_OPENS_MONTH_REPORT_SUCCESS:
      return {
        ...state,
        appOpensMonthReport: action.payload,
        loading: false,
      }
    case GET_ALL_USER_RESPONSES_SUCCESS:
      return {
        ...state,
        allUserResponses: action.payload,
        loading: false,
      }
    case RESET_ALL_USER_RESPONSES:
      return {
        ...state,
        allUserResponses: null,
      }
    case GET_FORM_BUILDER_PAYMENT_REPORTS_SUCCESS:
      return {
        ...state,
        formBuilderPaymentReports: action.payload,
        loading: false,
      }
    case GET_FORM_LIST_SUCCESS:
      return {
        ...state,
        formList: action.payload,
      }
    case GET_FEATURE_CLICKS_SUCCESS:
      return {
        ...state,
        featureClicks: action.payload,
      }
    case RESET_FEATURE_CLICKS:
      return {
        ...state,
        featureClicks: null,
      }
    case GET_FEATURE_VIEWS_BY_USER_SUCCESS:
      return {
        ...state,
        featureViewsByUser: action.payload,
      }
    case RESET_FEATURE_VIEWS_BY_USER:
      return {
        ...state,
        featureViewsByUser: null,
      }
    case DISPLAY_DEFAULT_REPORTS:
      return {
        ...state,
        dashboardReportsAreLoading: true,
      }
    case DISPLAY_DEFAULT_REPORTS_FAILED:
    case DISPLAY_DEFAULT_REPORTS_SUCCESS:
      return {
        ...state,
        dashboardReportsAreLoading: false,
      }
    case GET_ALL_FEATURE_REPORTS:
      return {
        ...state,
        featureReportsLoading: true
      }
    case GET_ALL_FEATURE_REPORTS_SUCCESS:
    case GET_ALL_FEATURE_REPORTS_FAILED:
      return {
        ...state,
        featureReportsLoading: false
      }
    default:
      return state
  }
}

export default Analytics
